// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#AdminUserRagEvaluate .base-card {
  border-radius: 8px;
  min-height: 720px;
  height: calc(100vh - 180px);
}
#AdminUserRagEvaluate .empty-state {
  height: calc(100vh - 420px);
}
#AdminUserRagEvaluate .page-container {
  margin-bottom: 0;
}
#AdminUserRagEvaluate .references-card {
  position: relative;
}
#AdminUserRagEvaluate .references-card .references-card-text {
  white-space: nowrap; /* 改行を防ぐ */
  overflow: hidden; /* 溢れた部分を非表示にする */
  text-overflow: ellipsis; /* 省略記号を表示する */
}
#AdminUserRagEvaluate .references-card .tool-tip-float {
  width: fit-content;
}
#AdminUserRagEvaluate .loading-box.light {
  --loading-color: var(--dark-color-dark-transparent-50);
}
#AdminUserRagEvaluate .loading-box.loading-mini {
  --base-size: 16px;
}
#AdminUserRagEvaluate .answer-date {
  color: var(--font_active_hidden_color);
}
#AdminUserRagEvaluate .util-row .rate-area {
  min-width: 320px;
  flex: 1 1;
}
#AdminUserRagEvaluate .util-row .button-area {
  min-width: 320px;
  flex: 2 1;
}
#AdminUserRagEvaluate .util-row .button-area .util-button-row {
  height: 72px;
}
#AdminUserRagEvaluate .util-row .button-area .util-button {
  padding: 8px 32px;
}
#AdminUserRagEvaluate .util-row .button-area .util-button.disabled:hover {
  background-color: transparent;
  cursor: default;
}
#AdminUserRagEvaluate .util-row .button-area .util-button .loading-modal-spinner {
  --loading-color: var(--primary-color-main-transparent-50);
}
#AdminUserRagEvaluate .util-row .circle-graph {
  --meter-color: var(--success-color-main);
  --meter-base-color: var(--warning-color-main);
  z-index: var(--z-index-local-over-1);
}
#AdminUserRagEvaluate .util-row .circle-graph.disabled {
  --meter-color: var(--disabled-bg-color);
  --meter-base-color: var(--disabled-border-color);
}
#AdminUserRagEvaluate .util-row .graph-area {
  position: relative;
}
#AdminUserRagEvaluate .util-row .graph-area .obj {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 2px;
  right: 0;
  margin: auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: var(--font_active_hidden_color);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 50px -10px;
}
#AdminUserRagEvaluate .util-row .limit-text {
  letter-spacing: 0.8px;
  margin-left: 8px;
}
#AdminUserRagEvaluate .util-row .value-text {
  letter-spacing: 0.8px;
  margin-bottom: -2px;
}
#AdminUserRagEvaluate .util-row .value-text span {
  color: var(--warning-color-main);
}
#AdminUserRagEvaluate .List .list-row {
  height: fit-content;
}
#AdminUserRagEvaluate .List .listitem {
  padding: 16px 8px;
}
#AdminUserRagEvaluate .List .listitem .flexible-textinput {
  background-color: transparent;
  border: none;
  border-color: transparent;
  transition: border-color 0.3s;
}
#AdminUserRagEvaluate .List .listitem .flexible-textinput:hover {
  border: 1px solid var(--border-color);
}
#AdminUserRagEvaluate .List .listitem.cell-eval_status .cell-item {
  height: 100%;
}
#AdminUserRagEvaluate .List .evaluate-list-loading {
  height: 40px;
  border-radius: 8px;
}
#AdminUserRagEvaluate .list-area {
  max-height: calc(100vh - 420px);
  overflow-x: hidden;
  overflow-y: auto;
}
#AdminUserRagEvaluate .middle-button {
  max-width: 15%;
}
#AdminUserRagEvaluate .long-button {
  max-width: 20%;
}
#AdminUserRagEvaluate .vlong-button {
  max-width: 25%;
}
#AdminUserRagEvaluate .addmergin {
  margin-top: 32px;
  padding-bottom: 32px;
}
#AdminUserRagEvaluate .status-item {
  border-radius: 8px;
  min-height: 96px;
  background-color: var(--white-color-main);
  color: var(--white-color-lightest);
}
#AdminUserRagEvaluate .status-item .feedback-tooltip .handle-button {
  border: none;
}
#AdminUserRagEvaluate .status-item.ok {
  background-color: var(--success-color-disabled);
  color: var(--success-color-dark);
}
#AdminUserRagEvaluate .status-item.ng {
  background-color: var(--danger-color-disabled);
  color: var(--danger-color-dark);
}
#AdminUserRagEvaluate .status-item.na {
  background-color: var(--disabled-bg-color);
  color: var(--disabled-font-color);
}
#AdminUserRagEvaluate .operate-button {
  padding: 0;
  min-height: 28px;
  max-height: 28px;
  min-width: 36px;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background-color: var(--white-color-lightest);
  transition: background-color 0.3s color 0.3s border 0.3s;
}
#AdminUserRagEvaluate .operate-button:hover {
  background-color: var(--dark-color-main);
  color: var(--white-color-main);
}
#AdminUserRagEvaluate .operate-button.danger:hover {
  background-color: var(--danger-color-main);
  border: 1px solid var(--danger-color-main);
  color: var(--white-color-lightest);
}
#AdminUserRagEvaluate .operate-button.primary {
  background-color: var(--primary-color-main);
  border: 1px solid var(--primary-color-main);
  color: var(--white-color-lightest);
}
#AdminUserRagEvaluate .operate-button.primary:hover {
  background-color: var(--primary-color-dark);
  color: var(--white-color-lightest);
}
#AdminUserRagEvaluate .operate-button .operate-label {
  height: 24px;
}
#AdminUserRagEvaluate .clipboard-area {
  border-radius: 8px;
  overflow: hidden;
  border: solid 1px var(--border-color);
}
#AdminUserRagEvaluate .clipboard-area .textinput {
  border: none;
}
#AdminUserRagEvaluate .clipboard-area .tag-input {
  padding-right: 48px;
  min-width: 320px;
}
#AdminUserRagEvaluate .clipboard-area .clipboard-button {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  width: 96px;
  height: 40px;
  border-left: solid 1px var(--border-color);
  border-radius: 0;
  background-color: var(--white-color-lightest);
  color: var(--font_active_sub_color);
}
#AdminUserRagEvaluate .clipboard-area .clipboard-button:hover {
  background-color: var(--white-color-main);
}
#AdminUserRagEvaluate .loading-modal-window {
  z-index: var(--z-index-loading);
  display: flex;
  opacity: 1;
}
#AdminUserRagEvaluate .loading-modal-window .loading-modal-spinner {
  --base-size: 64px;
  --loading-color: var(--primary-color-main-transparent-50);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/AdminUserRagEvaluate.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACZ;EACI,kBAAA;EACA,iBAAA;EACA,2BAAA;AACR;AAEI;EACI,2BAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,kBAAA;AAFR;AAIQ;EACI,mBAAA,EAAA,UAAA;EACA,gBAAA,EAAA,iBAAA;EACA,uBAAA,EAAA,cAAA;AAFZ;AAKQ;EACI,kBAAA;AAHZ;AAQQ;EACI,sDAAA;AANZ;AASQ;EACI,iBAAA;AAPZ;AAWI;EACI,sCAAA;AATR;AAcQ;EACI,gBAAA;EACA,SAAA;AAZZ;AAcQ;EACI,gBAAA;EACA,SAAA;AAZZ;AAcY;EACI,YAAA;AAZhB;AAeY;EACI,iBAAA;AAbhB;AAgBoB;EACI,6BAAA;EACA,eAAA;AAdxB;AAkBgB;EACI,yDAAA;AAhBpB;AAqBQ;EACI,wCAAA;EACA,6CAAA;EAOA,oCAAA;AAzBZ;AAoBY;EACI,uCAAA;EACA,gDAAA;AAlBhB;AAwBQ;EACI,kBAAA;AAtBZ;AAwBY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sCAAA;EAEA,iDAAA;AAxBhB;AA4BQ;EACI,qBAAA;EACA,gBAAA;AA1BZ;AA6BQ;EACI,qBAAA;EACA,mBAAA;AA3BZ;AA6BY;EACI,gCAAA;AA3BhB;AAiCQ;EACI,mBAAA;AA/BZ;AAkCQ;EACI,iBAAA;AAhCZ;AAkCY;EACI,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;AAhChB;AAkCgB;EACI,qCAAA;AAhCpB;AAwCgB;EACI,YAAA;AAtCpB;AA2CQ;EACI,YAAA;EACA,kBAAA;AAzCZ;AA6CI;EACI,+BAAA;EACA,kBAAA;EACA,gBAAA;AA3CR;AA8CI;EACI,cAAA;AA5CR;AA8CI;EACI,cAAA;AA5CR;AA8CI;EACI,cAAA;AA5CR;AA+CI;EACI,gBAAA;EACA,oBAAA;AA7CR;AAgDI;EACI,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kCAAA;AA9CR;AAiDY;EACI,YAAA;AA/ChB;AAmDQ;EACI,+CAAA;EACA,gCAAA;AAjDZ;AAmDQ;EACI,8CAAA;EACA,+BAAA;AAjDZ;AAmDQ;EACI,0CAAA;EACA,iCAAA;AAjDZ;AAqDI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,6CAAA;EACA,wDAAA;AApDR;AAsDQ;EACI,wCAAA;EACA,8BAAA;AApDZ;AAwDY;EACI,0CAAA;EACA,0CAAA;EACA,kCAAA;AAtDhB;AAyDQ;EACI,2CAAA;EACA,2CAAA;EACA,kCAAA;AAvDZ;AAyDY;EACI,2CAAA;EACA,kCAAA;AAvDhB;AA2DQ;EACI,YAAA;AAzDZ;AA6DI;EACI,kBAAA;EACA,gBAAA;EACA,qCAAA;AA3DR;AA6DQ;EACI,YAAA;AA3DZ;AA8DQ;EACI,mBAAA;EACA,gBAAA;AA5DZ;AA+DQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EAEA,WAAA;EACA,YAAA;EAEA,0CAAA;EAEA,gBAAA;EACA,6CAAA;EACA,mCAAA;AAhEZ;AAkEY;EACI,yCAAA;AAhEhB;AAqEI;EACI,+BAAA;EACA,aAAA;EACA,UAAA;AAnER;AAqEQ;EACI,iBAAA;EACA,yDAAA;AAnEZ","sourcesContent":["#AdminUserRagEvaluate{\r\n    .base-card{\r\n        border-radius: 8px;\r\n        min-height: 720px;\r\n        height: calc(100vh - 180px);\r\n    }\r\n\r\n    .empty-state{\r\n        height: calc(100vh - 420px);\r\n    }\r\n\r\n    .page-container{\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .references-card{\r\n        position: relative;\r\n\r\n        .references-card-text{\r\n            white-space: nowrap; /* 改行を防ぐ */\r\n            overflow: hidden; /* 溢れた部分を非表示にする */\r\n            text-overflow: ellipsis; /* 省略記号を表示する */\r\n        }\r\n\r\n        .tool-tip-float{\r\n            width: fit-content;\r\n        }\r\n    }\r\n\r\n    .loading-box {\r\n        &.light{\r\n            --loading-color: var(--dark-color-dark-transparent-50);\r\n        }\r\n\r\n        &.loading-mini{\r\n            --base-size: 16px;\r\n        }\r\n    }\r\n\r\n    .answer-date{\r\n        color: var(--font_active_hidden_color);\r\n    }\r\n\r\n    .util-row {\r\n        \r\n        .rate-area{\r\n            min-width: 320px;\r\n            flex: 1;\r\n        }\r\n        .button-area{\r\n            min-width: 320px;\r\n            flex: 2;\r\n\r\n            .util-button-row{\r\n                height: 72px;\r\n            }\r\n\r\n            .util-button {\r\n                padding: 8px 32px;\r\n\r\n                &.disabled{\r\n                    &:hover {\r\n                        background-color: transparent;\r\n                        cursor: default;\r\n                    }\r\n                }\r\n\r\n                .loading-modal-spinner {\r\n                    --loading-color: var(--primary-color-main-transparent-50);\r\n                }\r\n            }\r\n        }\r\n\r\n        .circle-graph {\r\n            --meter-color: var(--success-color-main);\r\n            --meter-base-color: var(--warning-color-main);\r\n\r\n            &.disabled{\r\n                --meter-color: var(--disabled-bg-color);\r\n                --meter-base-color: var(--disabled-border-color);\r\n            }\r\n            \r\n            z-index: var(--z-index-local-over-1);\r\n        }\r\n\r\n        .graph-area {\r\n            position: relative;\r\n\r\n            .obj{\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                bottom: 2px;\r\n                right: 0;\r\n                margin: auto;\r\n                width: 40px;\r\n                height: 40px;\r\n                border-radius: 50%;\r\n\r\n                color: var(--font_active_hidden_color);\r\n\r\n                box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 50px -10px;\r\n            }\r\n        }\r\n\r\n        .limit-text{\r\n            letter-spacing: 0.8px;\r\n            margin-left: 8px;\r\n        }\r\n\r\n        .value-text{\r\n            letter-spacing: 0.8px;\r\n            margin-bottom: -2px;\r\n\r\n            span{\r\n                color: var(--warning-color-main)\r\n            }\r\n        }\r\n    }\r\n\r\n    .List{\r\n        .list-row {\r\n            height: fit-content;\r\n        }\r\n\r\n        .listitem{\r\n            padding: 16px 8px;\r\n\r\n            .flexible-textinput {\r\n                background-color: transparent;\r\n                border: none;\r\n                border-color: transparent;\r\n                transition: border-color 0.3s;\r\n\r\n                &:hover{\r\n                    border: 1px solid var(--border-color);\r\n                }\r\n            }\r\n        }\r\n\r\n        .listitem\r\n        {\r\n            &.cell-eval_status{\r\n                .cell-item{\r\n                    height: 100%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .evaluate-list-loading{\r\n            height: 40px;\r\n            border-radius: 8px;\r\n        }\r\n    }\r\n\r\n    .list-area{\r\n        max-height: calc(100vh - 420px);\r\n        overflow-x: hidden;\r\n        overflow-y: auto;\r\n    }\r\n\r\n    .middle-button{\r\n        max-width: 15%\r\n    }\r\n    .long-button{\r\n        max-width: 20%\r\n    }\r\n    .vlong-button{\r\n        max-width: 25%\r\n    }\r\n\r\n    .addmergin{\r\n        margin-top: 32px;\r\n        padding-bottom: 32px;\r\n    }\r\n\r\n    .status-item{\r\n        border-radius: 8px;\r\n        min-height: 96px;\r\n        background-color: var(--white-color-main);\r\n        color: var(--white-color-lightest);\r\n\r\n        .feedback-tooltip{\r\n            .handle-button{\r\n                border: none;\r\n            }\r\n        }\r\n\r\n        &.ok{\r\n            background-color: var(--success-color-disabled);\r\n            color: var(--success-color-dark);\r\n        }\r\n        &.ng{\r\n            background-color: var(--danger-color-disabled);\r\n            color: var(--danger-color-dark);\r\n        }\r\n        &.na{\r\n            background-color: var(--disabled-bg-color);\r\n            color: var(--disabled-font-color);\r\n        }\r\n    }\r\n\r\n    .operate-button{\r\n        padding: 0;\r\n        min-height: 28px;\r\n        max-height: 28px;\r\n        min-width: 36px;\r\n        border-radius: 14px;\r\n\r\n        border: 1px solid var(--border-weak-color);\r\n        background-color: var(--white-color-lightest);\r\n        transition: background-color 0.3s color 0.3s border 0.3s;\r\n\r\n        &:hover{\r\n            background-color: var(--dark-color-main);\r\n            color: var(--white-color-main);\r\n        }\r\n\r\n        &.danger{\r\n            &:hover{\r\n                background-color: var(--danger-color-main);\r\n                border: 1px solid var(--danger-color-main);\r\n                color: var(--white-color-lightest);\r\n            }\r\n        }\r\n        &.primary{\r\n            background-color: var(--primary-color-main);\r\n            border: 1px solid var(--primary-color-main);\r\n            color: var(--white-color-lightest);\r\n\r\n            &:hover{\r\n                background-color: var(--primary-color-dark);\r\n                color: var(--white-color-lightest);\r\n            }\r\n        }\r\n\r\n        .operate-label{\r\n            height: 24px;\r\n        }\r\n    }\r\n\r\n    .clipboard-area{\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n        border: solid 1px var(--border-color);\r\n    \r\n        .textinput {\r\n            border: none;\r\n        }\r\n    \r\n        .tag-input {\r\n            padding-right: 48px;\r\n            min-width: 320px;\r\n        }\r\n    \r\n        .clipboard-button {\r\n            position: absolute;\r\n            top: 0;\r\n            bottom: 0;\r\n            margin: auto;\r\n            right: 0;\r\n    \r\n            width: 96px;\r\n            height: 40px;\r\n    \r\n            border-left: solid 1px var(--border-color);\r\n    \r\n            border-radius: 0;\r\n            background-color: var(--white-color-lightest);\r\n            color: var(--font_active_sub_color);\r\n    \r\n            &:hover {\r\n                background-color: var(--white-color-main);\r\n            }\r\n        }\r\n    }\r\n\r\n    .loading-modal-window{\r\n        z-index: var(--z-index-loading);\r\n        display: flex;\r\n        opacity: 1.0;\r\n\r\n        .loading-modal-spinner{\r\n            --base-size: 64px;\r\n            --loading-color: var(--primary-color-main-transparent-50);\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
